if (!customElements.get('sale-countdown')) {
  // Timers sharing a storage key (e.g. the header bar and the product page timer) read the same
  // end time and roll over to the same next end time, so they always show identical values.
  const memoryStore = {};

  const readEnd = (key) => {
    try {
      return Number(localStorage.getItem(key)) || Number(memoryStore[key]) || 0;
    } catch (error) {
      return Number(memoryStore[key]) || 0;
    }
  };

  const writeEnd = (key, value) => {
    memoryStore[key] = value;
    try {
      localStorage.setItem(key, String(value));
    } catch (error) {
      // Storage unavailable (private mode); the in-memory value keeps this page's timers in sync.
    }
  };

  customElements.define(
    'sale-countdown',
    class SaleCountdown extends HTMLElement {
      connectedCallback() {
        this.durationMs = (Number(this.dataset.durationSeconds) || 7200) * 1000;
        this.storageKey = `sale-countdown-end-${this.dataset.storageKey}`;

        this.hoursEl = this.querySelector('[data-countdown-hours]');
        this.minutesEl = this.querySelector('[data-countdown-minutes]');
        this.secondsEl = this.querySelector('[data-countdown-seconds]');

        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timeout);
      }

      getEndTime(now) {
        let end = readEnd(this.storageKey);

        if (!end) {
          end = now + this.durationMs;
          writeEnd(this.storageKey, end);
        } else if (end <= now) {
          // Advance by whole durations so every timer lands on the same new end time.
          end += Math.ceil((now - end + 1) / this.durationMs) * this.durationMs;
          writeEnd(this.storageKey, end);
        }

        return end;
      }

      tick() {
        const now = Date.now();
        const remaining = this.getEndTime(now) - now;
        const totalSeconds = Math.ceil(remaining / 1000);

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');

        // Wake just after the next whole-second boundary of the countdown so all timers flip together.
        this.timeout = setTimeout(this.tick.bind(this), (remaining % 1000 || 1000) + 10);
      }
    }
  );
}
